// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3cae68ae8ef5c790","5971":"fc1a284868b17ea3"}[chunkId] + ".css";
};